export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-snapchat-743fdc4a640b65567fdc7a63d37bbd7f.svg";